export enum ReceiptInputs {
	RecipientName = "recipientName",
	RecipientDocument = "recipientDocument",
	Observation = "observation",
}
